export const DEFAULT_PLACEHOLDERS = {
	brand_video: 'www.brandvideo.com',
	brand_website: 'www.brandwebsite.com',
	city: 'Los Angeles',
	choose_list: 'Choose from the list below',
	company_name: 'Company Name ',
	email: 'email@address.com',
	name: 'First Name Last Name',
	phone_number: '1 123-456-7890',
	job_title: 'Job Title',
	facebook_link: 'https://www.facebook.com/profilename',
	instagram_link: 'https://www.instagram.com/profilename',
	linkedin_link: 'https://www.linkedin.com/in/profilename',
	x_link: 'https://x.com/profilename',
	youtube_link: 'https://www.youtube.com/@profilename',
	tiktok_link: 'https://www.tiktok.com/@profilename',
	currency: '1,000,000'
};

export interface IErrorsObject {
	totalErrors: number;
	errors: Array<IErrorsFormatted>;
}

export interface IErrorsFormatted {
	fieldName: string;
	errorString: string;
}

export const formatErrors = (errors: any, labels: Record<string, string>): IErrorsObject => {
	const errorsFormatted: IErrorsFormatted[] = [];

	Object.keys(errors).forEach(field => {
		if (field === 'brokers') {
			Object.keys(errors.brokers).forEach(brokerIndex => {
				const brokerErrors = errors.brokers[brokerIndex];
				Object.keys(brokerErrors).forEach(errorKey => {
					errorsFormatted.push({
						fieldName: `Broker ${parseInt(brokerIndex, 10) + 1} ${labels[errorKey] || errorKey}`,
						errorString: brokerErrors[errorKey]
					});
				});
			});
		} else if (field === 'dimensions') {
			Object.keys(errors.dimensions).forEach(dimKey => {
				errorsFormatted.push({
					fieldName: `Dimensions: ` + labels[dimKey] || dimKey,
					errorString: errors.dimensions[dimKey]
				});
			});
		} else {
			errorsFormatted.push({
				fieldName: labels[field] || field,
				errorString: errors[field]
			});
		}
	});

	return {
		totalErrors: errorsFormatted.length,
		errors: errorsFormatted.slice(0, 5)
	};
};
